import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitReplaceText'
})
export class SplitReplaceTextPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    let result = value;
    console.log(value);
    args.forEach((arg, index) => {
      const placeholder = new RegExp(`\\{${index}\\}`, 'g');
      result = result.replace(placeholder, arg);
    });

    return result;
  }

}
